import { useEffect } from 'react';

export const useScrollTop = (trigger?: unknown) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [trigger]);
};
